export const config = {
	defaultSortName: "startDateTime" as const,
	defaultSortDirection: "desc" as const,
	defaultPageNumber: 1,
	fallbackFilters: {
		status: [],
		privateNotes: "any" as const,
		meetingDateStart: undefined,
		meetingDateEnd: undefined,
	},
	pageSize: 10,
	statusOptions: ["active", "completed", "canceled", "archived"] as const,
	privateNotesOptions: ["any", "has-private-notes", "no-private-notes"] as const,
	meetingDescriptionMaxLength: 2000,
};
